import { Component, Inject, OnInit } from '@angular/core';
import { Utils } from '../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { CreateExcellenceLeverPopupComponent } from './createexcellencelever-popup/createexcellencelever-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../../services/customdialog.service';
import { Router } from '@angular/router';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { BranchexcellenceChangelogFormComponent } from '../../branchexcellence-changelog-form/branchexcellence-changelog-form.component';
import { GroupFunctionRows } from '../group-function-rows';
import { ItemSelection } from '../item-selection';

@Component({
    selector: 'excellence-lever',
    templateUrl: './excellence-lever.component.html',
    styleUrls: ['./excellence-lever.component.less',
        '../branchexcellenceadmin.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    standalone: false
})
export class ExcellenceLeverComponent implements OnInit {

    subscriptionManagementId: any;
    subscriptions: any[] = [];
    readonly groups = new GroupFunctionRows<ExcellenceLever>(visibleItems => this.selection.retain(visibleItems));
    columnsToDisplay = ['Name', 'LineOfBusiness', 'Function', 'actions', 'ChangeLog'];

    isRemoveActive = false;
    readonly selection = new ItemSelection<ExcellenceLever>(item => item.ExcellenceLeverId);

    constructor(
        private http: HttpClient
        , private dialogForm: MatDialog
        , @Inject('BASE_URL') private baseUrl: string
        , private customDialog: CustomDialogService
        , private router: Router
        , public defaults: DefaultValuesService
        , private toastrService: ToastrService) { }

    ngOnInit(): void {
        // Just once to get user role in case of loading directly that component.
        // Remove actions item from columnsToDisplay
        if (!this.defaults.isMersyAdminBranchExcellenceUser)
            this.columnsToDisplay = this.columnsToDisplay.filter(item => item !== 'actions');
        this.getExcellenceLevers();
    }

    getExcellenceLevers() {
        Utils.httpGetExcellenceLevers(
            this.http,
            this.baseUrl,
            this,
            function (tthis: ExcellenceLeverComponent, list: ExcellenceLever[]) {
                tthis.groups.setItems(list);
            },
            null
        )
    }

    onRemoveExcellenceLever(element: ExcellenceLever) {
        this.customDialog.openConfirm({
            title: "Delete Excellence Lever",
            message: `Do you want to ${element.Name} - (${element.Function})?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed) {
                Utils.httpDeleteExcellenceLever(
                    this.http
                    , this.baseUrl
                    , element.ExcellenceLeverId
                    , this
                    , function (tthis: ExcellenceLeverComponent, result: any) {
                        if (result) {
                            tthis.getExcellenceLevers();
                            tthis.toastrService.success(`Excellence Lever was deleted successfully!`);
                        }
                        else
                            tthis.toastrService.error(`Excellence Lever could not be deleted. Please, contact with administrator`);
                    },
                    null
                );
            }
        });
    }

    onEditExcellenceLever(element: ExcellenceLever) {
        const dialog = this.dialogForm.open(CreateExcellenceLeverPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect'],
            disableClose: true,
            data: element,
        })

        dialog.afterClosed().subscribe(() => {
            this.getExcellenceLevers()
        })
    }

    openCreateExcellenceLeverPopup() {
        const dialog = this.dialogForm.open(CreateExcellenceLeverPopupComponent, {
            panelClass: ['custom-mat-dialog_v2', 'dialogNgselect'],
            disableClose: true,
        })

        dialog.afterClosed().subscribe(() => {
            this.getExcellenceLevers()
        })
    }

    onClickDownload() {
        Utils.httpDownloadExcellenceFactors(
            this.http,
            this.baseUrl,
            `ExcellenceLever`,
            'Lever');
    }

    onClickUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadExcellenceLever()]);
    }
    onClickTranslDownload() {
        Utils.httpDownloadExcellenceFactorsTransl(
            this.http,
            this.baseUrl,
            `ExcellenceLeverTransl`,
            'Lever');
    }

    onClickTranslUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadTranslLever()]);
    }

    onHistoryDetail(element: ExcellenceLever, type: string) {

        var excellenceLeverId = 0;

        if (element.ExcellenceLeverId != undefined)
            excellenceLeverId = element.ExcellenceLeverId;

        const Dialog = this.dialogForm.open(BranchexcellenceChangelogFormComponent, {
            disableClose: false,
            data: {
                element: element,
                id: excellenceLeverId,
                dataType: type
            }
        });
        Dialog.afterClosed().subscribe(() => {
        });
    }

    public toggleRemoveLever() {
        this.setRemoveMode(!this.isRemoveActive);
    }

    private setRemoveMode(active: boolean) {
        this.isRemoveActive = active;
        this.selection.clear();
    }

    onClickBulkRemove() {
        const ids = this.selection.ids;
        this.customDialog.openConfirm({
            title: "Remove selected Levers",
            message: `Do you want to remove ${ids.length} selected Levers? Please note that action cannot be rollbacked!`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpDeleteExcellenceLevers(
                    this.http
                    , this.baseUrl
                    , ids
                    , this
                    , function (tthis: ExcellenceLeverComponent) {
                        tthis.toastrService.success('Excellence Levers were removed successfully!');
                        tthis.setRemoveMode(false);
                        tthis.getExcellenceLevers();
                    },
                    function (tthis: ExcellenceLeverComponent) {
                        tthis.toastrService.error('Excellence Levers could not be removed. Please, contact with administrator');
                    }
                );
            }
        })
    }
}
